import styled from '@emotion/styled';

import { defaultTheme } from '../../lib/themes';

const PropertyInfoModalContainer = styled.div`
  color: #004b54;
  font-family: Inter;
`;

const PropertyInfoContainer = styled.div`
  font-size: 16px;
  line-height: 19px;
  min-width: 268px;

  & > * + * {
    margin-top: ${defaultTheme.spacing}px;
  }

  img:first-of-type + * {
    margin-top: ${defaultTheme.spacing * 2}px;
  }

  .bold {
    font-weight: bold;
  }

  .prices-container {
    display: flex;
    flex-direction: row-reverse;
    justify-content: space-between;
  }

  .date-info {
    color: #9d9d9d;
    font-size: 12px;
    line-height: 14px;
    margin-top: 22px;
  }

  .CTA {
    width: 100%;
    height: 40px;
    margin-top: 16px;
    background-color: #ffe33d;
    color: #004b54;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: bold;
    cursor: pointer;
    border: none;

    &:hover {
      background: #004b54;
      color: white;
    }
  }
`;

const PropertyImage = styled.img`
  border-radius: 5px;
  box-shadow: 0 1px 15px 0 rgba(0, 0, 0, 0.27);
  display: block;
  height: 90px;
  margin-top: -60px;
`;

const PropertyHighlight = styled.li`
  display: inline-block;
  font-size: 12px;
  line-height: 14px;

  &:before {
    color: #d8d8d8;
    content: '\u2022';
    font-size: 11px;
    padding: 0 6px;
  }

  &:first-of-type:before {
    content: '';
    padding: 0;
  }
`;

const PropertyCounter = styled.span``;

export {
  PropertyInfoModalContainer,
  PropertyInfoContainer,
  PropertyImage,
  PropertyHighlight,
  PropertyCounter,
};
